import {Component, Input} from "@angular/core";
import {Message, MessageType} from "../common/message";

@Component({
	selector: "device-message",
	template: `
		<div class="devicemessage {{messageTypeClass}}" [innerHTML]="message.text"></div>
	`,
})
export class DeviceMessageComponent {
	@Input() message: Message;

	get messageTypeClass(): string {
		switch (this.message.severity) {
			case MessageType.Success:
				return "devicemessage-success";
			case MessageType.Info:
				return "devicemessage-info";
			case MessageType.Alert:
				return "devicemessage-alert";
			case MessageType.Warning:
				return "devicemessage-warning";
			default:
				return "devicemessage-info";
		}
	}
}
